import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ComfortFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.98 4.48C20.78 10.92 20.78 14.12 18.98 19.44C13.18 17.64 10.98 17.64 5.02 19.44C3.22 13 3.22 9.8 5.02 4.48C10.82 6.28 13.02 6.28 18.98 4.48ZM6.68 6.32C5.2 9.72 5.2 13.48 6.68 17.6C7.9 13.78 7.9 10.02 6.68 6.32Z" />
    </SvgIcon>
  );
});
